export default {
    'alertsTitle.error': 'Hata!',
    'alertsTitle.success': 'Başarılı!',
    'alertsTitle.warning': 'Uyarı!',
    'alertsTitle.info': 'Bilgi!',
  };
  